import { Pipe, PipeTransform } from '@angular/core';
import { IQuestionChoices } from './../interfaces/radio-checkbox-config.interface';

@Pipe({
    name: 'filterByEducationLevel',
})
export class FilterByEducationLevelPipe implements PipeTransform {
    private maternelIds: number[] = [1, 2, 3, 4];
    public transform(value: IQuestionChoices[], arg?: number): any {
        return value.filter((choices: IQuestionChoices) =>
            arg === 2 ? this.maternelIds.includes(+choices.value) : !this.maternelIds.includes(+choices.value)
        );
    }
}
